<template>
  <div :style="style" ref="container">
    <Signature
      :closable="closable"
      @close="$emit('close')"
    >
      <slot v-if="meta.processType === 'numerar'">
        <div class="data-item-numeration">NNN</div>
      </slot>
      <slot v-if="meta.processType === 'tramitar'">
        <div class="data-item-process">T</div>
      </slot>
      <slot v-if="meta.processType === 'fechar'">
        <div class="data-item-date"> 2022-04-01</div>
      </slot>
    </Signature>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';

import Signature from '@/febos/global/pdf/components/Signature';
import SignatureBehaviors from '@/febos/global/pdf/mixins/SignatureBehaviors';

export default {
  mixins: [SignatureBehaviors],
  components: {
    Signature,
  },
  computed: {
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
    ...mapGetters('Empresas', [
      'company'
    ])
  },
  props: {
    closable: { type: Boolean, default: false },
    meta: { type: Object, required: true }
  }
};

</script>

<style>

.signature .data {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.signature .data-item-numeration {
  font-size: 26px;
  font-family: monospace;
  line-height: 40px;
}

.signature .data-item-process {
  font-size: 26px;
  font-family: monospace;
  line-height: 40px;
}

.signature .data-item-date {
  font-size: 16px;
  font-family: monospace;
  line-height: 20px;
}

</style>
